import { render } from "./FieldDetails.vue?vue&type=template&id=ab34247e"
import script from "./FieldDetails.vue?vue&type=script&lang=js"
export * from "./FieldDetails.vue?vue&type=script&lang=js"
script.render = render

export default script